import { render, staticRenderFns } from "./UpdateAllServices.vue?vue&type=template&id=3da1ee90&"
import script from "./UpdateAllServices.vue?vue&type=script&lang=js&"
export * from "./UpdateAllServices.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAllServices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports